import { render, staticRenderFns } from "./ReassignModal.vue?vue&type=template&id=1c23426c&scoped=true"
import script from "./ReassignModal.vue?vue&type=script&lang=js"
export * from "./ReassignModal.vue?vue&type=script&lang=js"
import style0 from "./ReassignModal.vue?vue&type=style&index=0&id=1c23426c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c23426c",
  null
  
)

export default component.exports